import { type IPlannedDates } from "@/lib/kinologg/kinologgTypes";
import { type QueryFunctionContext } from "@tanstack/react-query"

export default async function getPlannedDates(context: QueryFunctionContext): Promise<IPlannedDates[]> {
    const resp = await fetch(`/api/planneddates?${context.queryKey.slice(1).map(id => `tid=${id}`).join('&')}`, { method: "get" });
    return await resp.json() as IPlannedDates[];
}